import { BACK, FRONT } from './cameraLenses'

const PREFIX = 'anear-camera:session'

function storageKey(eventId) {
  return eventId ? `${PREFIX}:${eventId}` : PREFIX
}

/**
 * Guest choices (facing, lens, zoom, torch) outlive a single viewfinder mount.
 * A stay-open camera can be torn down when the display refreshes; the next
 * mount should open the camera they were just using.
 */
export function readCameraSession(eventId) {
  try {
    const scoped = eventId ? sessionStorage.getItem(storageKey(eventId)) : null
    const raw = scoped || sessionStorage.getItem(PREFIX)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : null
  } catch {
    return null
  }
}

export function writeCameraSession(eventId, session) {
  const payload = JSON.stringify({
    facing: session?.facing || '',
    deviceId: session?.deviceId || '',
    factor: Number.isFinite(session?.factor) ? session.factor : null,
    zoom: Number.isFinite(session?.zoom) ? session.zoom : null,
    torch: !!session?.torch
  })

  try {
    sessionStorage.setItem(PREFIX, payload)
    if (eventId) sessionStorage.setItem(storageKey(eventId), payload)
  } catch {
    // Private mode / quota — the in-memory selection still covers this mount.
  }
}

export function loadCameraSelection(eventId, fallbackFacing = FRONT) {
  const saved = readCameraSession(eventId)
  const facing = saved?.facing === FRONT || saved?.facing === BACK ? saved.facing : fallbackFacing

  return {
    facing,
    deviceId: typeof saved?.deviceId === 'string' ? saved.deviceId : '',
    factor: Number.isFinite(saved?.factor) ? saved.factor : null,
    zoom: Number.isFinite(saved?.zoom) ? saved.zoom : null,
    torch: !!saved?.torch
  }
}
